var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-qr-code-wrapper",class:_vm.position},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"qr-code-container"},[_c('img',{attrs:{"src":_vm._f("img2WebpFilter")(_vm.qrCode),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }